// extracted by mini-css-extract-plugin
export default {"box":"Checkbox_box__VfUzP","wrapper":"Checkbox_wrapper__MHck7","input":"Checkbox_input__JP6O6","icon":"Checkbox_icon__HncgQ","true":"Checkbox_true__H6Epf"};